import { axiosInstance, axiosUnauth } from '../utils/axiosInstance';
// eslint-disable-next-line import/no-cycle
import { IJobResponse } from '../interfaces/jobInterface';
// TODO: Why this eslint error???
// eslint-disable-next-line import/no-cycle
import {
  IApplicationOverQuotaData,
  ICompleteCallbackData,
  ICompleteCallbackResponse,
  IUpdateStatus,
} from '../interfaces';
import { getSessionIdFromCache } from './sessionService';

/**
 * Get FlexiQuiz details for Monday.com flow
 * @param quiz_id
 * @param response_id
 */
async function getFlexiQuiz(quiz_id: string, response_id: string) {
  try {
    const resp = await axiosInstance.get(`/flexiquiz/${quiz_id}/${response_id}`);
    return resp.data || {};
  } catch (e) {
    return {};
  }
}

const referrer = !document.referrer.includes('myint') && document.referrer;
/**
 * Get Interview details from Public link
 * @param jobSlug
 * @param companySlug
 * @param jobId
 * @param qid
 * @param rid
 */
const getPublicJob = async (
  jobId?: string,
  jobSlug?: string,
  companySlug?: string,
  qid?: string,
  rid?: string,
  signal?: AbortSignal,
  pageParam?: string,
  queryReferrer?: string,
):Promise<IJobResponse> => {
  let sessionId = getSessionIdFromCache();
  sessionId = sessionId ? `&session_id=${sessionId}` : '';
  const params = `${jobId ? `jobId=${jobId}${pageParam ? `&page=${pageParam}` : ''}` : `jobSlug=${jobSlug}&companySlug=${companySlug}${sessionId}${pageParam ? `&page=${pageParam}` : ''}`}${(referrer && !queryReferrer) ? `&referrer=${referrer}` : ''}`;
  const jobResponse = await axiosInstance.get(`/applications/public?${params}`, { signal });
  const { data } = jobResponse;
  let quizDetails: { firstName?: string, lastName?: string, email?: string } = {};
  if (qid && rid) {
    quizDetails = await getFlexiQuiz(qid, rid);
  } else if (data && data.quiz_id && rid) {
    quizDetails = await getFlexiQuiz(data.quiz_id, rid);
  }
  if (quizDetails.firstName && quizDetails.lastName && quizDetails.email) {
    data.quizDetails = quizDetails;
  }

  return data;
};

/**
 * Get Private invite details
 * @param candidateId
 */
const getPrivateJob = async (
  candidateId: string | undefined,
  signal?: AbortSignal,
  pageParam?: string,
  queryReferrer?: string,
):Promise<IJobResponse> => {
  let sessionId = getSessionIdFromCache();
  sessionId = sessionId ? `&session_id=${sessionId}` : '';
  return axiosInstance.get(`/applications/private?candidateId=${candidateId}${sessionId}${pageParam ? `&page=${pageParam}` : ''}${(referrer && !queryReferrer) ? `&referrer=${referrer}` : ''}`, { signal })
    .then((res) => res.data);
};

const updateStatus = async (data: IUpdateStatus):Promise<void> => {
  const res = await axiosInstance.put('/api/invitations/updateStatus', data);
  return res.data;
};

const completeCallback = async (data: ICompleteCallbackData):Promise<ICompleteCallbackResponse> => axiosInstance.put('/api/start/onCompleteCallback', { ...data, session_id: getSessionIdFromCache() });

const uploadToken = async (filename: string, type: string):Promise<any> => axiosInstance.get(`/s3/signed?filename=${filename}&type=${type}`);

// eslint-disable-next-line max-len
const uploadToS3 = (url: string, file: File, onProgress: (progressEvent: any)=>void) => axiosUnauth.put(url, file, {
  headers: { 'Content-Type': file.type },
  onUploadProgress: (progressEvent) => { onProgress(progressEvent); },
});

const sendApplicationOverQuota = (data:IApplicationOverQuotaData):Promise<void> => axiosInstance.post('/billing/applicationOverQuota', data);

const sendRecordLater = (candidate_id: string, event_id: string, authorization: string):Promise<void> => axiosInstance.post('/api/invitations/sendReminderImmediately', { candidate_id }, {
  headers: { authorization },
  params: {
    event_id,
  },
});

export {
  getPublicJob,
  getPrivateJob,
  updateStatus,
  completeCallback,
  uploadToken,
  uploadToS3,
  sendApplicationOverQuota,
  sendRecordLater,
};
